import { getConfig } from '../ConfigurationService';
import { Configuration } from '../ConfigurationService/ConfigurationService';

/* eslint typescript-sort-keys/string-enum: "error" */
export enum LocalStorageKey {
  AutomaticRemindersComplianceNoticeHidden = 'automatic_reminders_compliance_notice_hidden',
  CompanyInformationWidgetFullWidth = 'company_information_widget_full_width',
  CreditNoteExportType = 'creditnote_export_type',
  DashboardWidgets = 'dashboard_widgets',
  ExpenseHeaderCollapsed = 'expense_header_collapsed',
  ExpenseHeaderFields = 'expense_header_fields',
  ExpensePaymentQrCode = 'expense_payment_qr_code',
  ExpenseScanOverwrite = 'expense_scan_overwrite',
  ExportFieldsData = 'export_fields_data',
  InsightsLastExportAction = 'insights_last_export_action',
  InsightsLastOverview = 'insights_last_overview',
  InsightsPreviewEnabled = 'insights_preview_enabled',
  IntroStatesCollapsedIntroStates = 'introStates.collapsedIntroStates',
  InvoicingExportType = 'invoicing_export_type',
  PlanningAssigneeFilter = 'planning_assignee_filter',
  PlanningPreviewDialogLastShown = 'planning_preview_dialog_last_shown',
  PlanningTaskDetailCollapsibles = 'planning_task_detail_collapsibles',
  ProjectAssigneeFilter = 'project_assignee_filter',
  ProjectBudgetSectionCollapsed = 'project_budget_section_collapsed',
  ProjectDetailCollapsibles = 'project_detail_collapsibles',
  ProjectEntityTypeFilter = 'project_entity_type_filter',
  ProjectGroupDetailCollapsibles = 'project_group_detail_collapsibles',
  ProjectHeaderCollapsed = 'project_header_collapsed',
  ProjectMaterialDetailCollapsibles = 'project_material_detail_collapsibles',
  ProjectMeetingDetailCollapsibles = 'project_meeting_detail_collapsibles',
  ProjectTaskDetailCollapsibles = 'project_task_detail_collapsibles',
  ProjectsAdvanceInvoicesCollapsed = 'projects_advance_invoices_collapsed',
  ProjectsAdvancedFilters = 'projects_advanced_filters',
  ProjectsAdvancedFiltersOrder = 'projects_advanced_filters_order',
  ProjectsDefaultAddOption = 'projects_default_add_option',
  ProjectsDefaultAddTemplateId = 'projects_default_add_template_id',
  ProjectsInvoiceBundleGroups = 'projects_invoice_bundle_groups',
  ProjectsOverviewSmartFilters = 'projects_overview_smart_filters',
  ProjectsSelectedAdvancedFilter = 'projects_selected_advanced_filter',
  ProjectsTimelineView = 'projects_timeline_view',
  QuotationsAddToProjectImpactStrategy = 'quotations_add_to_project_impact_strategy',
  QuotationsExpiryBannersDismissed = 'quotations_expiry_banners_dismissed',
  QuotationsHeaderCollapsed = 'quotations_header_collapsed',
  QuotationsHeaderFields = 'quotations_header_fields',
}

const generateAccountAndEmployeeIdPrefix = () =>
  `${getConfig(Configuration.AccountId)}_${getConfig(Configuration.EmployeeId)}`;

export const generateLocalStorageWidgetKey = (context: string, label: string, id: string) => {
  if (context === 'company') {
    return `company_detail_${label.replace(' ', '-')}_${id}_widget_expanded`;
  }
};

export const getPreferenceFromLocalStorageForCurrentUser = (key: string, defaultValue?: any) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    const foundValue = localStorage.getItem(`${prefix}_${key}`);
    const parsedValue = foundValue && JSON.parse(foundValue);
    if (parsedValue === null) {
      return defaultValue;
    }
    return parsedValue;
  } catch {
    // localStorage not available
    return defaultValue;
  }
};

export const savePreferenceToLocalStorageForCurrentUser = (key: string, value: any) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    localStorage.setItem(`${prefix}_${key}`, JSON.stringify(value));
  } catch {
    // localStorage not available or QuotaExceededError
  }
};

export const removePreferenceFromLocalStorageForUser = (key: string) => {
  const prefix = generateAccountAndEmployeeIdPrefix();

  try {
    localStorage.removeItem(`${prefix}_${key}`);
  } catch {
    // localStorage not available
  }
};
